import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Link } from "react-router-dom";


function Teem() {
  const data = [
    {
      id: 1,
      img: "assets/images/team/team-4-1.png",
      name: "Brian S. Brooks",
      subname: "CEO & Founder",
    },
    {
      id: 2,
      img: "assets/images/team/team-4-2.png",
      name: "Jackie C. Waldman",
      subname: "Senior Manager",
    },
    {
      id: 3,
      img: "assets/images/team/team-4-3.png",
      name: "Tommy B. Brooks",
      subname: "Business Consultant",
    },
    {
      id: 4,
      img: "assets/images/team/team-4-4.png",
      name: "Kelvin E. Shumate",
      subname: "Junior Manager",
    },
    {
      id: 5,
      img: "assets/images/team/team-4-1.png",
      name: "Brian S. Brooks",
      subname: "CEO & Founder",
    },
    {
      id: 6,
      img: "assets/images/team/team-4-2.png",
      name: "Jackie C. Waldman",
      subname: "Senior Manager",
    },
    {
      id: 7,
      img: "assets/images/team/team-4-3.png",
      name: "Tommy B. Brooks",
      subname: "Business Consultant",
    },
    {
      id: 8,
      img: "assets/images/team/team-4-4.png",
      name: "Kelvin E. Shumate",
      subname: "Junior Manager",
    },
  ];

  return (
    <section className="team-four">
      <div className="container">
        <div className="sec-title text-center">
          <p className="sec-title__tagline">meet our team</p>

          <h3 className="sec-title__title">
            We’ve professional team members <br />
          </h3>
        </div>

        <Swiper
          loop={true}
          spaceBetween={30}
          slidesPerView={1}
          breakpoints={{
            576: {
              slidesPerView: 2,
            },
            992: {
              slidesPerView: 3,
            },
            1200: {
              slidesPerView: 4,
            },
          }}
        >
          {data.map((item) => (
            <SwiperSlide key={item.id}>
              <div className="team-four__card">
                <div className="team-four__card__image">
                  <img src={item.img} alt={item.name} />
                </div>

                <h3 className="team-card__title">
                  <Link to="/teamdetails">{item.name}</Link>
                </h3>

                <p className="team-card__designation">{item.subname}</p>

                <ul className="list-unstyled team-card__social">
                  <li>
                    <Link to="#">
                      <i className="fab fa-facebook-f" />
                    </Link>
                  </li>
                  <li>
                    <Link to="#">
                      <i className="fab fa-twitter" />
                    </Link>
                  </li>
                  <li>
                    <Link to="#">
                      <i className="fab fa-linkedin-in" />
                    </Link>
                  </li>
                  <li>
                    <Link to="#">
                      <i className="fab fa-instagram" />
                    </Link>
                  </li>
                </ul>

                <Link to="/teamdetails" className="team-four__card__link">
                  <i className="far fa-arrow-right" />
                </Link>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
}

export default Teem;
